export const LOGGING_TAG = "Player";

export const formatIceServers = (iceServers?: RTCIceServer[]) => {
  return (iceServers || []).map((e) => ({
    ...e,
    credential: (e.credential || "").replace(/./g, "*"),
    username: (e.username || "").replace(/./g, "*"),
  }));
};
